import type { ReactNode } from "react";
import ActivationDonut from "./ActivationDonut";
import { activationHeadline } from "./activation";
import { formatDateTime, formatRelative } from "./format";
import LoggedInInfo from "./LoggedInInfo";
import type { ActivationCounts } from "./types";

/** "Login data from Workvivo as of Oct 22, 2026 at 3:04 PM" */
export function ActivationAsOf({ finishedAt }: { finishedAt: string | null | undefined }) {
  const when = formatDateTime(finishedAt);
  if (!when) return null;
  return (
    <p className="directory-activation-asof" title={formatRelative(finishedAt) || undefined}>
      Login data from Workvivo as of {when}
    </p>
  );
}

/** Card with a headline (+ "Has logged in" info button), the "as of" line and the login donut + legend. */
export default function ActivationSummaryCard({
  counts,
  finishedAt,
  title,
  action,
  label = "Workvivo logins"
}: {
  counts: ActivationCounts;
  finishedAt: string | null | undefined;
  title?: string;
  action?: ReactNode;
  label?: string;
}) {
  return (
    <section className="directory-activation-card" aria-label={label}>
      <div className="directory-activation-card-text">
        {title ? <h2 className="directory-activation-card-title">{title}</h2> : null}
        <div className="directory-activation-headline-row">
          <p className="directory-activation-headline">{activationHeadline(counts)}</p>
          <LoggedInInfo />
        </div>
        <ActivationAsOf finishedAt={finishedAt} />
        {action ? <div className="directory-activation-card-action">{action}</div> : null}
      </div>
      <ActivationDonut counts={counts} />
    </section>
  );
}
